var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
		_vm.$s.Button,
		( _obj = {}, _obj[_vm.$s.selected] = _vm.isSelected, _obj ) ],on:{"click":_vm.selectSelf}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }